import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// ── Resource hints: preconnect to external domains ──────────────────────────
const addLink = (rel: string, href: string, extra?: Record<string, string>) => {
  const el = document.createElement('link');
  el.rel = rel;
  el.href = href;
  if (extra) Object.entries(extra).forEach(([k, v]) => el.setAttribute(k, v));
  document.head.appendChild(el);
};
// Preconnect to font origins (eliminates DNS + TLS handshake from critical path)
addLink('preconnect', 'https://fonts.googleapis.com');
addLink('preconnect', 'https://fonts.gstatic.com', {
  crossorigin: ''
});
// Preconnect to image CDN and FB pixel
addLink('preconnect', 'https://cdn.magicpatterns.com');
addLink('dns-prefetch', 'https://connect.facebook.net');
// Preload hero background image (LCP element)
addLink('preload', 'https://cdn.magicpatterns.com/uploads/a2Bnst1zYPLimQGBi5avRH/ChatGPT_Image_15_feb_2026,_09_53_29_p.m..png', {
  as: 'image',
  fetchpriority: 'high'
});
// Load Google Fonts non-blocking (media trick: loads as stylesheet once parsed)
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;0,800;1,400;1,700&family=Inter:wght@300;400;500;600;700&display=swap';
fontLink.media = 'print';
fontLink.onload = () => {
  fontLink.media = 'all';
};
document.head.appendChild(fontLink);
render(<App data-id="element-232" />, document.getElementById('root'));